import StationAssignmentTabs from './StationAssignmentTabs';

export default StationAssignmentTabs;
export * from './StationAssignmentTabs';
